// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageCanvas_container__3K-kc","overlay":"ImageCanvas_overlay__EIxRK"};